module.exports = __webpack_public_path__ + "media/src/images/partners/foggia-f39a47580cb96a21848b2ff51494b390.jpg";